// extracted by mini-css-extract-plugin
export default {"container":"style_container__156DW","box1":"style_box1__dxe09","box2":"style_box2__aYZCH","box3":"style_box3__mO4DJ","box4":"style_box4__smiRm","box5":"style_box5__iHlhJ"};